import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';

import {Banner} from '../Banner';

type LogLimitReachedBannerProps = {
  numLinesAvailable: number;
};

export const LogLimitReachedBanner = ({
  numLinesAvailable,
}: LogLimitReachedBannerProps) => {
  return (
    <Banner
      variant="warning"
      className="mb-16 items-start justify-start gap-16">
      <Icon name="warning" className="shrink-0" />
      <span>
        <span className="font-semibold">Partial logs displayed.</span> Only{' '}
        {numLinesAvailable.toLocaleString()} lines of your logs are shown due to
        storage limitations. These may not be the latest entries. Download log
        files to view full log output.
      </span>
    </Banner>
  );
};
